import React from 'react';
import {PropTypes} from 'prop-types';
import {ProductBox} from 'components/fair/fair-product';
import {connect} from 'react-redux';
import {Fairs, Products} from 'base/api';
import {SingleImageUploader} from 'components/uploader';
import ReactPaginate from 'react-paginate';
import {toastr} from 'react-redux-toastr';
import axios from 'axios';
import cookie from 'react-cookie';
import CONFIG from 'base/constants/config';
import Modal from 'react-modal'

class ProductList extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      items: {},
      products: [],
      total: 0,
      offset: 0,
      pageCount: 0,
      searchTerm: '',
      categoryId: [],
      API_URL: '',
      access_token: cookie.load('accessToken') || '',
      featuredBanner: '',
      featuredProductId: null,
      modalIsOpen: false,
      loading: false,
      edit: false
    }

    this.fnCount = 'products/approved/count';
    this.findStatus = 1;
  }

  componentWillMount () {
    Modal.setAppElement('body')
  }

  componentDidMount() {

    switch (this.props.status) {
      case 'AWAITING':
        this.fnCount = 'products/awaiting/count';
        this.findStatus = 0;
        break;
      case 'REJECTED':
        this.fnCount = 'products/rejected/count';
        this.findStatus = 2;
        break;
      default:
        this.findStatus = 1;
    }

    Fairs.actions.get.request({id: this.props.match.params.id}).then(response => {;
      if (response.data) {
        this.setState({
          API_URL: response.data.fair.apiUrl
        }, () => {
          this.getData();
        })
      }
    });
  }

  getData (params) {
    axios.get(`${this.state.API_URL}/${this.fnCount}`,{
      params,
      headers: {
        Authorization: `${this.state.access_token}`
      }
    }).then(response => {
      this.setState({total: response.data.total}, () => {this.loadProductsFromServer(this.findStatus);})
    }).catch(error => {
      console.log(error)
    })
  }

  loadProductsFromServer(status) {
    let params = {
      filter: {
        limit: this.props.limit,
        skip: this.state.offset,
        order: 'createdAt DESC',
        where: {
          status: status,
          name: {
            regexp: `/${this.state.searchTerm}/i`
          }
        }
      }
    }
    if (this.props.status !== 'ALL') {
      params.filter.where.status = status
    }

    axios({
      method: 'GET',
      url:`${this.state.API_URL}/products`,
      headers: {
        Authorization: `${this.state.access_token}`
      },
      params
    }).then(response => {
      let products = response.data || []
      this.postLoadProducts(products);
    }).catch(error => {
      console.log(error)
    })
  }

  postLoadProducts(products) {
    this.props.dispatch({
      type: 'UPDATE_LIST_PRODUCT_OF_FAIR',
      list: products
    });

    let itemKeys = {};
    products.map(item => {
      itemKeys[item.id] = item;
    });

    let pageCount = Math.ceil(this.state.total / this.props.limit);
    this.setState({
      items: itemKeys,
      pageCount
    });
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.products != this.state.products) {
      this.setState({
        products: nextProps.products,
        products: nextProps.products,
      });
    }
  }

  onChange(e) {
    this.setState({
      searchTerm: e.target.value,
      offset: 0
    });
  }

  handleSearch(e) {
    e.preventDefault();
    this.getData({q: this.state.searchTerm});
  }

  handlePageClick = (data) => {
    let selected = data.selected;
    let offset = Math.ceil(selected * this.props.limit);

    this.setState({offset: offset}, () => {
      this.loadProductsFromServer(this.findStatus);
    });
  };

  onDelete(id) {
    if (confirm("Bạn có muốn xóa sản phẩm này không?")) {
      axios({
        method: 'DELETE',
        url:`${this.state.API_URL}/products/${id}`,
        headers: {
          Authorization: `${this.state.access_token}`
        }
      }).then(response => {
        toastr.removeByType('success');
        toastr.success("", "Sản phẩm đã được xóa");
        this.getData({q: this.state.searchTerm});
      }).catch(error => {
        console.log(error)
      })
    }
  }

  accept(productId, type) {
    if (type === 'lock' ? confirm("Bạn chắc chắn muốn sản phẩm này tham gia hội chợ?") : confirm("Bạn đồng ý duyệt sản phẩm này?")) {
      axios({
        method: 'PATCH',
        url: `${this.state.API_URL}/products/${productId}/`,
        headers: {
          Authorization: `${this.state.access_token}`
        },
        data: {
          status: 1
        }
      }).then(response => {
        toastr.success("Thành công", `${type === 'lock' ? 'Sản phẩm đã được tham gia hội chợ' : "Duyệt thành công"}`);
        this.updateInfo(productId)
      }).catch(error => {
        console.log(error)
      })
    }
  }

  unAccept(productId, type) {
    if (type === 'lock' ? confirm("Bạn chắc chắn muốn khóa sản phẩm này?") : confirm("Bạn muốn từ chối sản phẩm này tham gia hội chợ?")) {
      axios({
        method: 'PATCH',
        url: `${this.state.API_URL}/products/${productId}/`,
        headers: {
          Authorization: `${this.state.access_token}`
        },
        data: {
          status: 2
        }
      }).then(response => {
        toastr.success("Thành công", `${type === 'lock' ? 'Khóa thành công' : "Từ chối thành công"}`);
        this.updateInfo(productId)
      }).catch(error => {
        console.log(error)
      })
    }
  }

  updateInfo(productId) {
    axios({
      method: 'POST',
      url: `${this.state.API_URL}/products/${productId}/approveUpdateInfo/`,
      headers: {
        Authorization: `${this.state.access_token}`
      }
    }).then(response => {
      this.getData({q: this.state.searchTerm});
    }).catch(error => {
      console.log(error)
    })
  }

  onModify(id) {
    var promotionalPrice = prompt('Nhập giá áp dụng cho hội chợ:','');
    if (typeof promotionalPrice === 'string' && promotionalPrice.trim() === '') {
      if (confirm("Vui lòng nhập giá áp dụng cho hội chợ của sản phẩm")) {
        this.onModify(id)
      }
    } else if (typeof promotionalPrice === 'string') {
      let data = {
        promotionalPrice
      }
      axios({
        method: 'PATCH',
        url:`${this.state.API_URL}/products/${id}`,
        data,
        headers: {
          Authorization: `${this.state.access_token}`
        }
      }).then(response => {
        axios({
          method: 'POST',
          url:`${this.state.API_URL}/products/${id}/approveUpdateInfo`,
          headers: {
            Authorization: `${this.state.access_token}`
          }
        }).then(response => {
          toastr.removeByType('success');
          toastr.success("", "Cập nhật giá thành công");
          this.getData({q: this.state.searchTerm});
        }).catch(error => {
          console.log(error)
        })
      }).catch(error => {
        console.log(error)
      })
    }
  }

  confirmFeaturedProduct(id) {
    this.setState({modalIsOpen: true, featuredProductId: id})
  }

  updateBannerProduct(id, featuredBanner) {
    this.setState({modalIsOpen: true, featuredProductId: id, featuredBanner, edit: true})
  }

  removeFeaturedProduct(id) {
    if(confirm('Bạn chắc chắn muốn hủy sản phầm nổi bật này?')) {
      axios({
        method: 'PATCH',
        url:`${this.state.API_URL}/products/${id}`,
        data: {
          isFeatured: false
        },
        headers: {
          Authorization: `${this.state.access_token}`
        }
      }).then(response => {
        axios({
          method: 'POST',
          url:`${this.state.API_URL}/products/${id}/approveUpdateInfo`,
          headers: {
            Authorization: `${this.state.access_token}`
          }
        }).then(response => {
          toastr.removeByType('success');
          toastr.success("", "Hủy sản phẩm nổi bật thành công");
          this.getData({q: this.state.searchTerm});
        }).catch(error => {
          console.log(error)
        })
      }).catch(error => {
        console.log(error)
      })
    }
  }

  setFeaturedProduct(id) {
    if(confirm(`Bạn chắc chắn muốn đặt sản phẩm này là nổi bật?`)) {
      this.setState({loading: true})
      let data = {
        isFeatured: true
      }
      axios({
        method: 'PATCH',
        url:`${this.state.API_URL}/products/${id}`,
        data,
        headers: {
          Authorization: `${this.state.access_token}`
        }
      }).then(response => {
        axios({
          method: 'POST',
          url:`${this.state.API_URL}/products/${id}/approveUpdateInfo`,
          headers: {
            Authorization: `${this.state.access_token}`
          }
        }).then(response => {
          toastr.removeByType('success');
          toastr.success("", "Đặt sản phẩm nổi bật thành công");
          this.closeModal();
          this.getData({q: this.state.searchTerm});
        }).catch(error => {
          console.log(error)
          this.setState({loading: false})
        })
      }).catch(error => {
        this.setState({loading: false})
        console.log(error)
      })
    }
  }

  closeModal() {
    this.setState({featuredProductId: null, modalIsOpen: false, featuredBanner: '', loading: false, edit: false})
  }

  onRemoveImage() {
    this.setState({featuredBanner: ''})
  }

  onUploadComplete(image) {
    this.setState({
      featuredBanner: image.name
    });
  }

  upload(url, data) {
    return new Promise((resolve, reject) => {
      axios({
        method: 'POST',
        url:`${this.state.API_URL}/containers/products/upload`,
        headers: {
          Authorization: `${this.state.access_token}`
        },
        data: data.data
      }).then(response => {
        resolve(response);
      }).catch(error => {
        reject(error);
      })
    })
  }

  render() {
    return (
      <div>
        <form className="search-container" onSubmit={this.handleSearch.bind(this)}>
          <i className='fa fa-search' />
          <input type="text" className="search-input" value={this.state.searchTerm} placeholder="Tìm theo tên sản phẩm" onChange={this.onChange.bind(this)}/>
          <button type='submit' className='btn-submit'>Tìm kiếm</button>
        </form>
        <div className='row'>
          <div className="container-fluid">
            <div className='row'>
              {
                this.state.products.map(products => {
                  return (
                    <div className='col-lg-3 col-md-6 fair-products'>
                      <ProductBox key={products.id} {...products} accept={this.accept.bind(this)} unAccept={this.unAccept.bind(this)} match={this.props.match} updateBannerProduct={this.updateBannerProduct.bind(this)} setFeaturedProduct={this.setFeaturedProduct.bind(this)} removeFeaturedProduct={this.removeFeaturedProduct.bind(this)} onDelete={this.onDelete.bind(this)} onModify={this.onModify.bind(this)}/>
                    </div>
                  );
                })
              }
            </div>
          </div>
        </div>
        <ReactPaginate previousLabel={"previous"}
          nextLabel={"next"}
          breakLabel={<a href="">...</a>}
          breakClassName={"break-me"}
          pageCount={this.state.pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={this.handlePageClick}
          containerClassName={"pagination"}
          subContainerClassName={"pages pagination"}
          activeClassName={"active"} />

          <Modal
            isOpen={this.state.modalIsOpen}
            onRequestClose={this.closeModal.bind(this)}
            className='modal-custom'
          >
            <div className='title-block'>
              <button className='btn-close' onClick={this.closeModal.bind(this)}>×</button>
            </div>
            <div className='wrap-content-modal'>
              <h4 className='content-message'>Banner sản phẩm nổi bật</h4>
              <SingleImageUploader
                fnUpload={this.upload.bind(this)}
                onUploadComplete={this.onUploadComplete.bind(this)}
                onRemoveImage={this.onRemoveImage.bind(this)}
                title='Ảnh, banner cho sản phẩm tiêu biểu, kích thước đề xuất: 1300x400'
                image={this.state.featuredBanner}
                type='PRODUCT'
                isProductFair
                API_URL_FAIR={`${this.state.API_URL}/containers`}
              />
              <div className='wrap-btn-action'>
                <button className='btn btn-primary' disabled={this.state.loading} onClick={this.setFeaturedProduct.bind(this)}>{this.state.edit === true ? 'Cập nhật' : 'Thêm'}</button>
              </div>
            </div>
          </Modal>
      </div>
    );
  }
}

const mapStateToProps = function(state) {
  return {
    products: state.fairs.products
  };
}

ProductList.PropTypes = {
  status: PropTypes.oneOf(['AWAITING', 'ALL', 'REJECTED']),
  limit: PropTypes.number
}

ProductList.defaultProps = {
  status: 'ALL',
  limit: 10
}

export default connect(mapStateToProps)(ProductList);


// WEBPACK FOOTER //
// ./components/fair/fair-product/ProductList.jsx